export enum NextHappening {
  SHG = 'SHG',
  HML = 'HML',
  ANY = 'ANY',
  ROOM_CLEANUP = 'ROOM_CLEANUP'
}